import { useSettings } from "@/providers/general/settings-provider";

import { AiChatPanel } from "./ai-chat-panel";

export function DarwinAI() {
    const { currentSettings } = useSettings();

    if (!currentSettings.DARWIN_AI_ENABLED) return null;

    return <AiChatPanel />;
}
